import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-4 sf-pro"
}
const _hoisted_2 = { class: "text-xl font-bold pt-4 mb-2" }
const _hoisted_3 = { class: "text-lg font-bold my-1" }
const _hoisted_4 = { class: "whitespace-pre-line" }
const _hoisted_5 = { class: "text-lg font-bold my-1" }
const _hoisted_6 = { class: "whitespace-pre-line" }
const _hoisted_7 = { class: "text-xl font-bold pt-4 mb-2" }
const _hoisted_8 = { class: "text-lg font-bold my-1" }
const _hoisted_9 = { class: "whitespace-pre-line" }

import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { inject, ref, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'PredispositionToDiseasesAccordion',
  props: /*@__PURE__*/_mergeModels({
    matrix: {},
    hasPremiumAccess: { type: Boolean }
  }, {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const isOpen = _useModel<boolean>(__props, "modelValue");
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(
      DestinyMatrixKeysEnum.PREDISPOSITION_TO_DISEASES
    );
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccordionComponent, {
    type: "white",
    onOpened: getData,
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    isBlocked: !__props.hasPremiumAccess
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.predisposition-to-diseases")), 1)
    ]),
    "faq-content": _withCtx(() => [
      (description.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(description.value["titles"]["heritage_diseases"]), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(description.value["titles"]["father_line_diseases"]), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(description.value["parents_diseases"]["male_line"]), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(description.value["titles"]["mather_line_diseases"]), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(description.value["parents_diseases"]["female_line"]), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(description.value["titles"]["minuses_diseases"]), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(description.value['diseases'], (disease, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(description.value["titles"]["what_personality_trigger_diseases"]), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(disease), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    "collapse-text-btn": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.collapse")), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "isBlocked"]))
}
}

})